import { Checkbox, FormControlLabel } from "@mui/material";
import { ReactElement } from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";

export function RhfCheckboxField<T extends FieldValues>(
  props: UseControllerProps<T> & { label?: string; disabled?: boolean }
): ReactElement {
  const { label, disabled, ...controllerProps } = props;

  const { field } = useController(controllerProps);

  return (
    <FormControlLabel
      control={
        <Checkbox
          value={field.value}
          checked={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          ref={field.ref}
          disabled={disabled}
        />
      }
      label={label}
    />
  );
}
